export const earlyBird = (course) => {
  const until = course?.early_bird_until ? new Date(course.early_bird_until) : null;
  const pct = course?.early_bird_pct || 0;
  const active = !!until && !!pct && new Date() <= until;
  const f = active ? 1 - pct / 100 : 1;
  return {
    active,
    pct,
    until,
    price: Math.round((course?.price || 0) * f),
    deposit: Math.round((course?.deposit || 0) * f),
    installment: Math.round((course?.installment_amount || 0) * f),
  };
};
